import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'removeHTML'})

export class RemoveHTML implements PipeTransform {
  transform(value: string): string {
  	if (typeof value !== "string") {
    	  return value;
  	}
  	return value.replace(/<[^>]*>/g, '');  
  }
}